export default __webpack_public_path__ + "static/media/img_step_lucia02_m.cd60288f.jpg";